import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type ProjectPriority = {
  priorityId: string;
  organisationId: string;
  priorityName: string;
};

export type ProjectPrioritiesResponse = ResponseType<ProjectPriority[]>;

function useAllProjectPrioritiesQuery(enabled = true) {
  return useQuery<
    AxiosResponseAndError<ProjectPrioritiesResponse>["response"],
    AxiosResponseAndError<ProjectPrioritiesResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.projectPriorities],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.project + "/project-priorities"),
    enabled: enabled,
    staleTime: 60000,
  });
}

export default useAllProjectPrioritiesQuery;
